<template>
  <Chip class="dual-chip uppercase">
    <span class="dual-chip-left" :class="leftSeverityClasses">
      <slot name="left">
        {{ leftLabel }}
      </slot>
    </span>

    <span class="dual-chip-right" :class="rightSeverityClasses">
      <slot name="right">
        {{ rightLabel }}
      </slot>
    </span>
  </Chip>
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';

import { useSeverityClasses } from '@rygen/rygen-ui/composables';
import { Severity } from '@rygen/rygen-ui/model';

import Chip from 'primevue/chip';

const props = defineProps({
  leftLabel: {
    type: String,
    default: () => '',
  },
  rightLabel: {
    type: String,
    default: () => '',
  },
  leftSeverity: {
    type: String as PropType<Severity>,
    default: () => null,
  },
  rightSeverity: {
    type: String as PropType<Severity>,
    default: () => null,
  },
});
const { leftLabel, rightLabel, leftSeverity, rightSeverity } = toRefs(props);

defineSlots<{
  left: () => any;
  right: () => any;
}>();

const leftSeverityClasses = useSeverityClasses(leftSeverity, 'dual-chip-');
const rightSeverityClasses = useSeverityClasses(rightSeverity, 'dual-chip-');
</script>

<style>
.dual-chip.p-chip {
  --p-chip-gap: 0;

  font-size: 10px;
  font-weight: 700;
  padding: 0;

  .dual-chip-success {
    background: var(--success-color);
    color: var(--success-light-color);
  }

  .dual-chip-success.light {
    background: var(--success-light-color);
    color: var(--success-color);
  }

  .dual-chip-info {
    background: var(--info-color);
    color: var(--info-light-color);
  }

  .dual-chip-info.light {
    background: var(--info-light-color);
    color: var(--info-color);
  }

  .dual-chip-warning {
    background: var(--warning-light-color);
    color: var(--warning-dark-color);
  }

  .dual-chip-danger {
    background: var(--danger-light-color);
    color: var(--danger-color);
  }

  .dual-chip-left {
    border-top-left-radius: 16px;
    border-bottom-left-radius: 16px;
    padding: var(--sp-1) var(--sp-1) var(--sp-1) var(--sp-2);
  }

  .dual-chip-right {
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
    padding: var(--sp-1) var(--sp-2) var(--sp-1) var(--sp-1);
  }
}
</style>
